import styled from "styled-components";

// Libraries
import { Dialog, IconButton, DialogContent, FormControl } from "@libraries/mui";

/** Atoms */
import { TabPanel } from "@atoms/index";

import { windowWidth } from "@styles/global";

// Telluria
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

const Container = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 10px !important;
    min-width: 470px !important;
    max-width: 470px !important;
    min-height: 500px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }

  .MuiDialogContent-root {
    padding: 0 24px !important;
  }

  * .default-field {
    min-width: 410px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 100% !important;
    }
  }
`;

const CustomDialogContent = styled(DialogContent)`
  @media (max-width: ${windowWidth.mobile.large}) {
    padding: 0 !important;
  }
`;

const ContentContainer = styled.div`
  @media (max-width: ${windowWidth.mobile.large}) {
    /** step tabs and control buttons */
    :nth-child(2),
    :last-child {
      padding-left: 1px;
      padding-right: 1px;
    }
  }
`;

const CustomTabPanel = styled(TabPanel)`
  @media (max-width: ${windowWidth.tablet}) {
    padding: 0 10px;
  }
`;

const ConcretingRequestContent = styled.div`
  padding: 15px 10px 7px 0;
`;

const ActionsContent = styled.div`
  padding: 15px 10px 7px 0;
`;

const CustomFormControl = styled(FormControl)`
  width: 0px !important;
  margin-top: 20px !important;
`;

const SelectItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;

  > :first-child {
    div {
      width: 22px;
      height: 22px;
    }
  }
`;

const MessagesContent = styled.div`
  padding: 15px 10px 0 0;
`;

const DialogActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  button {
    color: #9400ee;
  }
`;

const CustomIconButton = styled(IconButton)`
  position: absolute !important;
  right: 8px;
  top: 11px;
  color: ${({ theme }) => theme.colors.primary} !important;
`;

export {
  Container,
  CustomDialogContent,
  ContentContainer,
  CustomTabPanel,
  ConcretingRequestContent,
  ActionsContent,
  CustomFormControl,
  SelectItem,
  MessagesContent,
  DialogActions,
  CustomIconButton
};
